import { useEffect, useState } from 'react';
import { Input, Modal, Space } from 'antd';
import { getFullName } from '@/utils';
import { useGetChildSearchResultsQuery, useQuickSearchChildrenMutation } from '@/services/child-api';
import Table from '@/components/table';
import Button from '@/components/button';
import { useGetChildInquiryMutation } from '@/services/parent-api';

const AddModal = ({ parentId, open, onClose, isRecommended, setSelectedChild }) => {
  const [seachText, setSearchText] = useState('');
  const [searchChildren, { isLoading: loadingSearch }] = useQuickSearchChildrenMutation();
  const [getChildInquiry, { isLoading: loadingChildInquiry }] = useGetChildInquiryMutation();

  const [searchId, setSearchId] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const { data, isFetching } = useGetChildSearchResultsQuery(
    { searchId, pageNumber, pageSize: 5 },
    { skip: !searchId },
  );

  useEffect(() => {
    if (open) {
      setSearchId();
      setSearchText('');
    }
  }, [open]);

  const onSearch = async (value) => {
    if (loadingSearch || !value) return;
    try {
      const res = await searchChildren({ searchText: value }).unwrap();
      setSearchId(res);
      setPageNumber(1);
    } catch (err) {}
  };

  const childSelected = async (value) => {
    const res = await getChildInquiry({ parentId, childId: value.childId, event: isRecommended }).unwrap();
    const child = { ...res[0], child: value };
    setSelectedChild(child);
    onClose();
  };

  const columns = [
    {
      title: 'Child ID',
      dataIndex: 'childCode',
    },
    {
      title: 'Child',
      dataIndex: 'name',
      render: (value) => getFullName(value),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value) => value.name,
    },
    {
      title: 'Siblings',
      dataIndex: 'siblings',
      render: (value) => (
        <Space direction="vertical" size={0}>
          {value.map((item) => (
            <span key={item.childId}>{getFullName(item.name)}</span>
          ))}
        </Space>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (value) => (
        <Button size="small" onClick={() => childSelected(value)}>
          Select
        </Button>
      ),
    },
  ];

  return (
    <Modal
      title="Add Inquiry"
      open={open}
      cancelText="Close"
      onCancel={onClose}
      confirmLoading={loadingChildInquiry}
      width={800}
      footer={null}
    >
      <Input.Search
        placeholder="Child Code"
        allowClear
        value={seachText}
        onChange={(e) => setSearchText(e.target.value)}
        onSearch={onSearch}
        style={{ marginBottom: 16 }}
      />

      {(searchId || loadingSearch) && (
        <Table
          columns={columns}
          dataSource={data?.data}
          rowKey="childId"
          loading={loadingSearch || isFetching}
          size="small"
          pagination={
            data?.count > data?.pageSize && {
              size: 'small',
              showQuickJumper: true,
              showSizeChanger: false,
              total: data.count,
              pageSize: data.pageSize,
              current: data.pageNumber,
              onChange: setPageNumber,
            }
          }
        />
      )}
    </Modal>
  );
};

export default AddModal;
